import React from 'react';
import { Box, Container } from '@mui/material';
import MUITypography from '../../Components/MUITypography';
import { align_center, align_column } from '../../Styles/VMStyles';

const privacySections = [
  {
    title: 'Refunds',
    content: [
      'All sales are final. Our subscription-based payment model does not accommodate refunds.',
      'Refunds are not issued once the payment is processed.',
    ],
  },
  {
    title: 'Non-Refundable Rates',
    content: [
      'All subscription rates and packages are non-refundable.',
      'Please review the terms and conditions of your specific subscription for details.',
    ],
  },
  {
    title: 'Force Majeure',
    content: [
      'In cases of unforeseen circumstances beyond our control (natural disasters, pandemics, government restrictions, etc.), we will not issue refunds.',
      'Alternative solutions such as subscription extensions or credits may be considered on a case-by-case basis.',
    ],
  },
  {
    title: 'Contact Us',
    content: [
      'For any questions or concerns regarding your subscription, please contact our customer service team at info@venuemanagercrm.com or +91 88975 45660.',
    ],
  },
];

function VMRefundPolicy() {
  return (
    <Container maxWidth="md">
      {/* PAGE TITLE */}
      <MUITypography
        align="center"
        gutterBottom
        sx={{ mt: 3, mb: 4, fontWeight: 700, ...align_center }}
      >
        Refund Policy
      </MUITypography>

      {/* SECTIONS */}
      {privacySections.map((section, sectionIndex) => (
        <Box key={sectionIndex} sx={{ mt: 3, ...align_column }}>
          {/* Section Title */}
          <MUITypography sx={{ fontWeight: 600, mb: 1 }}>
            {sectionIndex + 1}. {section.title}
          </MUITypography>

          {/* Sub Items */}
          <Box sx={{ pl: 3 }}>
            {section.content.map((item, itemIndex) => (
              <MUITypography
                key={itemIndex}
                color="text.secondary"
                sx={{ mb: 0.8 }}
              >
                {sectionIndex + 1}.{itemIndex + 1} {item}
              </MUITypography>
            ))}
          </Box>
        </Box>
      ))}

      {/* FOOTER NOTE */}
      <MUITypography
        variant="h4"
        sx={{ mt: 5, textAlign: 'center' }}
        label="Thank you for choosing our services. We are committed to providing you with the best experience and look forward to serving you."
      />
    </Container>
  );
}

export default VMRefundPolicy;
